export default {
  VIDEO: "Video",
  ACTIVITY: "Activity",
  TAG: "Secondary Content Tag",
  EXTERNAL: "External Link",
};
